export class Language {

    public static getCurrentLang(): string {
        const lang = localStorage.getItem('payLang');
        return lang ? lang : 'hy';
    }

    public static setCurrentLang(lang: string, updatePage: boolean) {
        localStorage.setItem('payLang', lang);
        if (updatePage) {
            const path: string = '/' + lang + window.location.pathname.substring(3);
            window.location.pathname = path;
        }
    }
}